// src/config/i18n.js

/**
 * Build locale configuration from environment variables
 * Priority: Private vars → Public vars → Fallback
 */
function buildLocaleConfig(env) {
  const fallbackLocales = ['en', 'es', 'it'];

  /**
   * Parse locale string from env vars
   * Supports comma-separated format: "en,es,it"
   */
  const parseLocales = (value) => {
    if (!value) return [...fallbackLocales];

    const parsed = value
      .split(',')
      .map((entry) => entry.trim())
      .filter(Boolean);

    return parsed.length > 0 ? parsed : [...fallbackLocales];
  };

  // ✅ FIXED: Priority - private SUPPORTED_LOCALES first, then NEXT_PUBLIC_
  const supportedLocales = parseLocales(
    env.SUPPORTED_LOCALES || env.NEXT_PUBLIC_SUPPORTED_LOCALES
  );

  // ✅ FIXED: Priority - private DEFAULT_LOCALE first, then NEXT_PUBLIC_
  const defaultLocaleCandidate = (
    env.DEFAULT_LOCALE || env.NEXT_PUBLIC_DEFAULT_LOCALE
  )?.trim();

  const defaultLocale = supportedLocales.includes(defaultLocaleCandidate)
    ? defaultLocaleCandidate
    : supportedLocales[0];

  // ✅ FIXED: Use SITE_URL first (private), then fallback to NEXT_PUBLIC_BASE_URL
  // Removed the redundant NEXT_PUBLIC_BASE_URL check
  const siteUrl = (
    env.SITE_URL ||
    env.NEXT_PUBLIC_BASE_URL ||
    'https://asktheoracle.io'
  ).replace(/\/$/, '');

  return {
    SUPPORTED_LOCALES: supportedLocales,
    DEFAULT_LOCALE: defaultLocale,
    SITE_URL: siteUrl,
  };
}

// ✅ Build config from process.env
const { SUPPORTED_LOCALES, DEFAULT_LOCALE, SITE_URL } =
  buildLocaleConfig(process.env);

// ✅ Export individual variables
export { DEFAULT_LOCALE, SITE_URL, SUPPORTED_LOCALES };

/**
 * Optional: Export as object for easier importing
 * Usage: import { localeConfig } from '@/config/i18n'
 * Then: localeConfig.DEFAULT_LOCALE
 */
export const localeConfig = {
  DEFAULT_LOCALE,
  SITE_URL,
  SUPPORTED_LOCALES,
};
